import { SvgIcon, SvgIconProps } from "@mui/material";

export const EditIcon2 = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<path
				d="M5.83325 5.83333H4.99992C4.55789 5.83333 4.13397 6.00893 3.82141 6.32149C3.50885 6.63405 3.33325 7.05797 3.33325 7.5V15C3.33325 15.442 3.50885 15.866 3.82141 16.1785C4.13397 16.4911 4.55789 16.6667 4.99992 16.6667H12.4999C12.9419 16.6667 13.3659 16.4911 13.6784 16.1785C13.991 15.866 14.1666 15.442 14.1666 15V14.1667M13.3333 4.16667L15.8333 6.66667M16.9874 5.48759C17.3156 5.15938 17.5 4.71424 17.5 4.25009C17.5 3.78594 17.3156 3.34079 16.9874 3.01259C16.6592 2.68438 16.2141 2.5 15.7499 2.5C15.2858 2.5 14.8406 2.68438 14.5124 3.01259L7.49992 10.0001V12.5001H9.99992L16.9874 5.48759Z"
				stroke="#FAFAFA"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};
